import z from 'zod';

export const CreatorProductPaidAtRankControllerReqBodySchema = z.object({
  customer_order_id: z.number(),
  original_product_ids: z.array(z.number()),
});

export const CreatorRankingsRequestSchema = z.object({
  type: z.enum(['realtime', 'monthly', 'weekly']),
  date: z.coerce.date(),
});
